export const SELECTABLE_USERS_COLORS_COUNT = 21;

export const SELECTABLE_USERS_COLOR_PREFIX = "selected-user-";
